<template>
  <div>
    <div v-if="video">
      <div class="columns">
        <div class="column is-one-third">
          <figure class="image is-16by9" v-if="video.image_url">
            <img :src="video.image_url" :alt="video.name">
          </figure>
        </div>
        <div class="column is-two-thirds">
          <h4 class="title is-4">
            <a href="javascript:void(0)" @click.prevent="back">
              <b-icon icon="chevron-left" size="is-small"></b-icon>
            </a>
            &nbsp;
            {{video.name}}
          </h4>
          <p class="subtitle is-6">
            {{video.author}}
            <span v-if="video.author">@</span>
            {{video.credit}}
            <br>
            {{video.published_at}}
          </p>
          <div class="tags">
            <span class="tag is-primary" :key="tag" v-for="tag in video.tags">{{tag}}</span>
          </div>

          <div class="buttons">
            <a
              :href="`https://www.supersport.com${video.url}`"
              target="_blank"
              class="button is-primary"
            >View Online</a>
            <router-link
              class="button is-primary"
              :to="`/videos/reimport?id=${video.ss_id}`"
            >Reimport</router-link>
          </div>
        </div>
      </div>
      <hr>
      <div class="columns" v-if="editableVideo">
        <div class="column">
          <!-- name -->
          <div class="field">
            <label class="label">
              <b-tooltip position="is-right" label="Name of the video" dashed type="is-dark">Name</b-tooltip>
            </label>
            <div class="control">
              <input class="input" type="text" v-model="editableVideo.name">
            </div>
          </div>
          <!-- url -->
          <div class="field">
            <label class="label">
              <b-tooltip position="is-right" label="URL of the video" dashed type="is-dark">URL</b-tooltip>
            </label>
            <div class="control">
              <input class="input" type="text" v-model="editableVideo.url">
            </div>
          </div>
          <!-- uri -->
          <div class="field">
            <label class="label">
              <b-tooltip position="is-right" label="URI of the video" dashed type="is-dark">URI</b-tooltip>
            </label>
            <div class="control">
              <input class="input" type="text" v-model="editableVideo.uri">
            </div>
          </div>
          <!-- category -->
          <div class="field">
            <label class="label">
              <b-tooltip
                position="is-right"
                label="Category of the video"
                dashed
                type="is-dark"
              >Category</b-tooltip>
            </label>
            <div class="control">
              <input class="input" type="text" v-model="editableVideo.category">
            </div>
          </div>
          <!-- description -->
          <div class="field">
            <label class="label">
              <b-tooltip
                position="is-right"
                label="Description of the video"
                dashed
                type="is-dark"
              >Description</b-tooltip>
            </label>
            <div class="control">
              <textarea class="textarea" rows="5" v-model="editableVideo.description"></textarea>
            </div>
          </div>
        </div>
        <div class="column">
          <!-- tags -->
          <div class="field">
            <label class="label">
              <b-tooltip position="is-right" label="Tags of the video" dashed type="is-dark">Tags</b-tooltip>
            </label>
            <div class="control">
              <input class="input" type="text" v-model="editableVideo.tags">
            </div>
          </div>
          <!-- stream url -->
          <div class="field">
            <label class="label">
              <b-tooltip
                position="is-right"
                label="Stream URL of the video"
                dashed
                type="is-dark"
              >Stream URL</b-tooltip>
            </label>
            <div class="control">
              <input class="input" type="text" v-model="editableVideo.stream_url">
            </div>
          </div>
          <!-- duration -->
          <div class="field">
            <label class="label">
              <b-tooltip
                position="is-right"
                label="Duration of the video"
                dashed
                type="is-dark"
              >Duration</b-tooltip>
            </label>
            <div class="control">
              <input class="input" type="number" min="1" v-model="editableVideo.duration">
            </div>
          </div>
          <!-- ss id -->
          <div class="field">
            <label class="label">
              <b-tooltip
                position="is-right"
                label="SS ID of the video"
                dashed
                type="is-dark"
              >SuperSport ID</b-tooltip>
            </label>
            <div class="control">
              <input class="input" type="number" min="1" v-model="editableVideo.ss_id">
            </div>
          </div>
          <!-- ss id -->
          <div class="field">
            <label class="label">
              <b-tooltip
                position="is-right"
                label="Channel of the video"
                dashed
                type="is-dark"
              >Channel</b-tooltip>
            </label>
            <div class="control">
              <input class="input" type="text" v-model="editableVideo.channel">
            </div>
          </div>
          <!-- visible -->
          <div class="field">
            <label class="label">
              <b-tooltip
                position="is-right"
                label="If disabled video will be hidden on all frontends"
                dashed
                type="is-dark"
              >Visible</b-tooltip>
            </label>
            <b-switch v-model="editableVideo.visible" type="is-success"></b-switch>
          </div>
          <!-- save button -->
          <div class="field">
            <button class="button is-primary" @click="updateArticle">Save Details</button>
          </div>
        </div>
      </div>
    </div>
    <div v-else>
      <loading></loading>
    </div>
  </div>
</template>

<script>
import Loading from "@/components/Loading";
import { SET_VIDEO } from "@/store/mutations";
import { GET_VIDEO, UPDATE_VIDEO } from "@/store/actions";

export default {
  name: "video-single",
  components: {
    Loading
  },
  data() {
    return {
      editableVideo: null
    };
  },
  computed: {
    videoId() {
      return this.$route.params.id;
    },
    video() {
      return this.$store.state.video.item;
    }
  },
  watch: {
    video(newVal, oldVal) {
      this.editableVideo = { ...this.video };
      if (this.editableVideo.tags) {
        this.editableVideo.tags = this.video.tags.join(",");
      }
    }
  },
  mounted() {
    if (!this.video || this.video.id !== this.videoId) {
      this.getVideo();
    }
  },
  methods: {
    getVideo() {
      this.$store.commit(SET_VIDEO, null);
      this.$store.dispatch(GET_VIDEO, this.videoId);
    },
    updateArticle() {
      this.$store.dispatch(UPDATE_VIDEO, this.editableVideo);
    },
    back(){
      history.back();
    }
  }
};
</script>
